const getModelId = (modelName: string) => {
  return modelName
}

export default getModelId
